import { render } from "./IdentityManagerGrantForm.vue?vue&type=template&id=8d9b09be"
import script from "./IdentityManagerGrantForm.vue?vue&type=script&lang=js"
export * from "./IdentityManagerGrantForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__